import PropTypes from "prop-types";
import React from "react";
import I18n from "i18n-js";

import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Linking,
} from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";
import { currencyFormatter } from "../helpers/currency";

class PrescriptionHistoryItemDetail extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      prescriptionNo: PropTypes.string,
      lifepackSubscriptionId: PropTypes.string,
      patientName: PropTypes.string.isRequired,
      prescriptionDate: PropTypes.string,
      redeemDate: PropTypes.string,
    }),
    detail: PropTypes.object.isRequired,
    navigation: PropTypes.object.isRequired,
    onDestinationChange: PropTypes.func,
  };

  static defaultProps = {
    onDestinationChange: () => {
      console.log("onDestinationChange is not implemented!");
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      products: [],
      totalPayment: 0,
      payments: {
        subtotal_price: 0,
        discount: 0,
        total_price: 0,
        delivery_price: 0,
      },
      invoiceUrl: "",
      prescriptionUrl: "",
      claimId: "",
    };
  }

  calculateProducts() {
    const { detail } = this.props;

    const products = [];
    const payments = {
      subtotal_price: 0,
      discount: 0,
      total_price: 0,
      delivery_price: 0,
    };
    let totalPayment = 0;

    if (!detail.prescription_order_histories) {
      return;
    }

    if (detail.prescription_order_histories.length === 0) {
      return;
    }

    // filter first history for products
    const history = detail.prescription_order_histories[0];

    const history_product = detail.prescription_order_histories.product;

    if (history_product) {
      history.product.map((product) => {
        products.push(product);
        totalPayment += product.price || 0;
      });
    }

    // filter histories that has payments
    const paymentHistories = detail.prescription_order_histories.filter(
      (order) => !!order.payment
    );

    if (paymentHistories.length > 0) {
      const paymentHistory = paymentHistories[0];
      payments.subtotal_price = paymentHistory?.payment?.subtotal_price || 0;
      payments.discount = paymentHistory?.payment?.discount || 0;
      payments.total_price = paymentHistory?.payment?.total_price || 0;
      payments.delivery_price = paymentHistory?.payment?.delivery_price || 0;
    }

    // filter histories that have claim ID
    const claimHistories = detail.prescription_order_histories.filter(
      (order) => !!order.claim_id
    );

    if (claimHistories.length > 0) {
      const claimHistory = claimHistories[0];
      this.setState({ claimId: claimHistory.claim_id });
    }

    // filter histories that have invoice URL
    const invoiceHistories = detail.prescription_order_histories.filter(
      (order) => !!order.invoice_url
    );

    if (invoiceHistories.length > 0) {
      const invoiceHistory = invoiceHistories[0];
      this.setState({ invoiceUrl: invoiceHistory.invoice_url });
    }

    //filter histories that have prescription URL
    const prescriptionHistories = detail.prescription_order_histories.filter(
      (order) => !!order.prescription_image
    );

    if (prescriptionHistories.length > 0) {
      const prescriptionHistory = prescriptionHistories[0];
      this.setState({
        prescriptionUrl: prescriptionHistory.prescription_image,
      });
    }

    // set up address delivery
    if (prescriptionHistories.length > 0) {
      const prescriptionHistory = prescriptionHistories[0];
      if(prescriptionHistory.patient.address != null) {
        const deliveryAddress = prescriptionHistory.patient.address?.second_line ?? "";
        const deliveryPostalCode =
          prescriptionHistory.patient.address?.postal_code ?? "";
        const newAddressDelivery =
          deliveryAddress != null
            ? deliveryAddress + " " + deliveryPostalCode
            : "-";
        this.setState({
          address: newAddressDelivery,
        });
      }
    }

    this.setState({
      products,
      totalPayment,
      payments,
    });
  }

  componentDidMount() {
    this.calculateProducts();
  }

  render() {
    const { data, themeColors, navigation, detail } = this.props;
    const {
      payments,
      totalPayment,
      invoiceUrl,
      prescriptionUrl,
      claimId,
      address,
    } = this.state;

    return (
      <View>
        <View style={{ marginLeft: 20, marginRight: 20 }}>
          <View>
            <View style={styles.container}>
                <View style={styles.detailContainer}>
                  <Text
                    style={[
                      styles.section,
                      fonts.bold,
                      { color: themeColors.primary },
                    ]}
                  >
                    {I18n.t("prixa.orderInfo")}
                  </Text>
              </View>
              <View style={styles.statusContainer}>
                <TouchableOpacity
                  disabled={
                    !claimId || data.patientClass.toLowerCase() !== "group"
                  }
                  onPress={() => {
                    const { onDestinationChange } = this.props;
                    onDestinationChange(`geniclick://claim/${claimId}`);
                  }}
                  style={{
                    backgroundColor:
                      claimId && data.patientClass.toLowerCase() === "group"
                        ? staticColors.forestFern
                        : '#F2F2F2',
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingVertical: 8,
                    paddingHorizontal: 16,
                    borderRadius: 30,
                  }}
                >
                  <Text
                    style={[
                      fonts.bold,
                      {
                        color: staticColors.white,
                        textAlign: "center",
                        fontSize: 10,
                        textTransform: "uppercase",
                      },
                    ]}
                  >
                    {I18n.t("prixa.prescriptionClaim")}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>

            <View style={[styles.container, styles.containerBorder]}>
              <View style={styles.detailFullContainer}> 
                <View style={styles.itemContainer}>
                  <View>
                    <Text style={styles.labelRegular}>{`${I18n.t(
                      "prixa.lifepackSubscriptionId"
                    )}`}</Text>
                    <Text style={styles.regularBold}>{data.lifepackSubscriptionId}</Text>
                  </View>
                </View>
                <View style={styles.itemContainer}>
                  <View>
                    <Text style={styles.labelRegular}>{`${I18n.t(
                      "prixa.prescriptionNoAlt"
                    )}`}</Text>
                    <Text style={styles.regularBold}>{data.prescriptionNo}</Text>
                  </View>
                </View>
                <View style={styles.itemContainer}>
                  <View>
                    <Text style={styles.labelRegular}>{`${I18n.t(
                      "prixa.redeemDate"
                    )}`}</Text>
                    <Text style={styles.regularBold}>{data.redeemDate}</Text>
                  </View>
                </View>
                <View style={styles.itemContainer}>
                  <View>
                    <Text style={styles.labelRegular}>{`${I18n.t(
                      "prixa.prescriptionDate"
                    )}`}</Text>
                    <Text style={styles.regularBold}>{data.prescriptionDate}</Text>
                  </View>
                </View>
                <View style={styles.itemContainer}>
                  <View>
                    <Text style={styles.labelRegular}>{`${I18n.t(
                      "prixa.prescriptionPatient"
                    )}`}</Text>
                    <Text style={styles.regularBold}>{data.patientName}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={{ marginTop: 16 }}>
            <View>
              <Text
                style={[
                  styles.section,
                  fonts.bold,
                  { color: themeColors.primary },
                ]}
              >
                {I18n.t("prixa.prescriptionDelivery")}
              </Text>
            </View>

            <View style={[styles.container, styles.containerBorder]}>
              <View style={styles.detailContainer}>
                <Text style={[styles.regularBold, { textTransform: "capitalize" }]}>
                  {detail.order_status || "-"}
                </Text>
              </View>
              <View style={styles.statusContainer}>
                <TouchableOpacity
                  style={{
                    backgroundColor: staticColors.forestFern,
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingVertical: 8,
                    paddingHorizontal: 16,
                    marginBottom: 8,
                    borderRadius: 30,
                  }}
                  onPress={() => {
                    const { detail } = this.props;
                    const {
                      cardNumber,
                      fullName,
                      gender,
                    } = navigation.state.params;
                    navigation.navigate("PrescriptionHistoryDetailStatus", {
                      data: detail.prescription_order_histories,
                      cardNumber,
                      fullName,
                      gender,
                    });
                  }}
                >
                  <Text
                    style={[
                      fonts.bold,
                      {
                        color: staticColors.white,
                        textAlign: "center",
                        fontSize: 10,
                        textTransform: "uppercase",
                      },
                    ]}
                  >
                    {I18n.t("prixa.prescriptionDeliveryView")}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
          <View style={{ marginTop: 16 }}>
            <View>
              <Text
                style={[
                  styles.section,
                  fonts.bold,
                  { color: themeColors.primary },
                ]}
              >
                {I18n.t("prixa.prescriptionPayment")}
              </Text>
            </View>

            <View style={[styles.container, styles.containerBorder]}>
              <View style={styles.detailFullContainer}>
                <View style={styles.itemContainer}>
                  <View style={styles.paymentContainer}>
                    <Text style={styles.paymentLabel}>
                      {I18n.t("prixa.prescriptionPaymentMedicine")}
                    </Text>
                    <Text style={{...styles.paymentText }}>
                      {currencyFormatter(payments.subtotal_price)}
                    </Text>
                  </View>
                </View>
                <View style={styles.itemContainer}>
                  <View style={styles.paymentContainer}>
                    <Text style={styles.paymentLabel}>
                      {I18n.t("prixa.prescriptionPaymentDelivery")}
                    </Text>
                    <Text style={{...styles.paymentText }}>
                      {currencyFormatter(payments.delivery_price)}
                    </Text>
                  </View>
                </View>
                <View style={styles.itemContainer}>
                  <View style={styles.paymentContainer}>
                    <Text
                      style={{
                        ...styles.paymentLabel,
                        ...fonts.bold,
                        color: themeColors.primary,
                      }}
                    >
                      {I18n.t("prixa.prescriptionPaymentTotal")}
                    </Text>
                    <Text
                      style={{
                        ...styles.regularBold,
                        color: themeColors.primary,
                      }}
                    >
                      {currencyFormatter(payments.total_price)}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={{ marginTop: 16 }}>
            <View>
              <Text
                style={[
                  styles.section,
                  fonts.bold,
                  { color: themeColors.primary },
                ]}
              >
                {I18n.t("prixa.prescriptionDeliveryDetail")}
              </Text>
            </View>

            <View style={[styles.container]}>
              <View style={styles.detailFullContainer}>
                <View style={styles.itemContainer}>
                  <View>
                    <Text style={styles.labelRegular}>{`${I18n.t(
                      "prixa.prescriptionDeliveryDetailRecipientName"
                    )}`}</Text>
                    <Text style={styles.regularBold}>{data.patientName}</Text>
                  </View>
                </View>
                <View style={styles.itemContainer}>
                  <View>
                    <Text style={styles.labelRegular}>{`${I18n.t(
                      "prixa.cellphoneNumber"
                    )}`}</Text>
                    <Text style={styles.regularBold}>
                      {detail.patient_phone || "-"}
                    </Text>
                  </View>
                </View>
                <View style={styles.itemContainer}>
                  <View>
                    <Text style={styles.labelRegular}>{`${I18n.t(
                      "prixa.addressDelivery"
                    )}`}</Text>
                    <Text style={styles.addressText}>{address || "-"}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
        <View style={{
          marginTop:30,
          flexDirection:"row",
          alignItems:"center",
          backgroundColor: staticColors.forestFern,
        }}>
          <View style={{
            backgroundColor: !!invoiceUrl
                    ? themeColors.darkerPrimary
                    : staticColors.grey,
            height: 60,
            width: "50%",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <TouchableOpacity
                disabled={!invoiceUrl}
                onPress={() => {
                  Linking.openURL(invoiceUrl);
                }}
              >
                <Text
                  style={[
                    fonts.bold,
                    {
                      color: staticColors.white,
                      textAlign: "center",
                      fontSize: 15,
                      textTransform: "capitalize",
                    },
                  ]}
                >
                  {I18n.t("prixa.prescriptionPaymentDownload")}
                </Text>
              </TouchableOpacity>
          </View>
          <View style={{
            backgroundColor: !!prescriptionUrl
                    ? staticColors.forestFern
                    : '#C0C0C0',
            height: 60,
            width: "50%",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <TouchableOpacity
                disabled={!prescriptionUrl}
                onPress={() => {
                  Linking.openURL(prescriptionUrl);
                }}
              >
                <Text
                  style={[
                    fonts.bold,
                    {
                      color: staticColors.white,
                      textAlign: "center",
                      fontSize: 15,
                      textTransform: "capitalize",
                    },
                  ]}
                >
                  {I18n.t("prixa.prescriptionDownload")}
                </Text>
              </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    paddingTop: 8,
  },
  containerBorder: {
    borderBottomColor: staticColors.grey,
    borderBottomWidth: 1,
    paddingBottom: 16,
  },
  buttonContainer: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  detailFullContainer: {
    flexDirection: "column",
  },
  detailContainer: {
    flex: 0.6,
    flexDirection: "column",
  },
  bulletContainer: {
    width: 10,
  },
  itemContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginBottom: 10,
  },
  paymentContainer: {
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
  },
  statusContainer: {
    flex: 0.4,
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  section: {
    fontSize: 16,
    ...fonts.regular,
  },
  paymentText: {
    fontSize: 12,
    marginVertical: 1,
    ...fonts.bold,
    textAlign: "right",
  },
  paymentLabel: {
    fontSize: 12,
    textAlign: "right",
  },
  regularBig: {
    fontSize: 14,
    ...fonts.regular,
  },
  regularBold: {
    fontSize: 12,
    color: '#000',
    marginVertical: 2,
    ...fonts.bold
  },
  labelRegular: {
    fontSize: 11,
    marginVertical: 2,
    color: staticColors.grey
  },
  addressText: {
    fontSize: 12,
    ...fonts.bold,
    flex: 1,
    flexWrap: "wrap",
    marginRight: 5,
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
}))(PrescriptionHistoryItemDetail);
